import React, { useEffect, ComponentProps } from 'react';
import { useAuthentication } from '../../../v2/LoginPageV2';
import { Button, ButtonTheme } from '@apply/components';

type ButtonProps = ComponentProps<typeof Button>;
export interface ApplicationEntrySaveAndExitButtonProps {
    saveAndExitButtonProps: ButtonProps;
    printMode?: boolean;
}

export const ApplicationEntrySaveAndExitButton: React.FC<ApplicationEntrySaveAndExitButtonProps> = ({
    saveAndExitButtonProps,
    printMode,
}) => {
    const { authentication, isAuthenticated } = useAuthentication();

    useEffect(() => {
        if (!authentication) {
            return;
        }

        if (!isAuthenticated) {
            if (!window.location.pathname.startsWith('/login')) {
                window.location.href = '/login';
            }
        }
    }, [authentication, isAuthenticated]);

    return (
        <>
            <div style={{ float: 'right' }}>
                <Button
                    id={saveAndExitButtonProps.id}
                    dataTestid={saveAndExitButtonProps.dataTestid}
                    theme={ButtonTheme.LinkBlue}
                    disabled={saveAndExitButtonProps.disabled}
                    handleClick={saveAndExitButtonProps.handleClick}
                    visible={saveAndExitButtonProps.visible}
                >
                    {saveAndExitButtonProps.children}
                </Button>
            </div>
        </>
    );
};
